// Google CAF parameters
export const GoogleCaf = {
  // Lower cased query key name (all query param keys are lower-cased while parsing)
  queryParam: {
    AFD_TOKEN: "afdtoken", // adsense token from the related links
    PCSA: "pcsa", // don't know what that is, usually set to false
    QUERY: "query", // keyword or term that was clicked or searched which resulted into sponsored listings
    SEARCH: "search", // set to 1 if the sponsored listings is the result of a search
  },
  blockType: {
    SEARCH_BOX: "searchbox",
    ADS: "ads",
    TEXT_ADS: "textads",
    RELATED_SEARCH: "relatedsearch",
  },
  adsafe: {
    ADULT_ONLY: "adultonly",
    MEDIUM: "medium",
    HIGH: "high",
    LOW: "low",
  },
  styleId: {
    // predefined style for the ads only (does not affect the related links)
    DEFAULT: "7621175430", // other styling parameters for ad elements will be ignored
    LIGHT_BLUE: "1293544924",
    SIMPLE_2C_LIGHT: "1293544924",
    VERTICAL_LINES: "1293544924",
    PARK_WEB: "7949183650",
    PARK_WEB_HEG: "7949183650",
    ARROW: "7621175430",
  },
};
